import { createTypes, createAction } from 'lib/action'

// *load ข้อมูล dashboard
const LOAD_COMMAND_CENTER_DASHBOARD_STOCK = createTypes(
  'loadCommandCenterDashboardStock',
  'load'
)

// *load division
const COMMAND_CENTER_DASHBOARD_LOAD_DIVISION = createTypes(
  'commandCenterLoadDivision',
  'load'
)

// *load department
const COMMAND_CENTER_DASHBOARD_LOAD_DEPARTMENT = createTypes(
  'commandCenterLoadDepartment',
  'load'
)

// *load section
const COMMAND_CENTER_DASHBOARD_LOAD_SECTION = createTypes(
  'commandCenterLoadSection',
  'load'
)

// *load plant
const COMMAND_CENTER_DASHBOARD_LOAD_PLANT = createTypes(
  'commandCenterLoadPlant',
  'load'
)

// *remove lists
const REMOVE_LISTS = `REMOVE_LISTS`

// *remove lists
function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

// *load ข้อมูล dashboard
const loadCommandCenterDashboardStock = {
  request: (data) =>
    createAction(LOAD_COMMAND_CENTER_DASHBOARD_STOCK.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(LOAD_COMMAND_CENTER_DASHBOARD_STOCK.SUCCESS, {
      lists,
    }),
  failure: () => createAction(LOAD_COMMAND_CENTER_DASHBOARD_STOCK.FAITLURE),
}

// *load division
const commandCenterLoadDivision = {
  request: (data, loading) =>
    createAction(COMMAND_CENTER_DASHBOARD_LOAD_DIVISION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(COMMAND_CENTER_DASHBOARD_LOAD_DIVISION.SUCCESS, { lists }),
  failure: () => createAction(COMMAND_CENTER_DASHBOARD_LOAD_DIVISION.FAITLURE),
}

// *load department
const commandCenterLoadDepartment = {
  request: (data, loading) =>
    createAction(COMMAND_CENTER_DASHBOARD_LOAD_DEPARTMENT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(COMMAND_CENTER_DASHBOARD_LOAD_DEPARTMENT.SUCCESS, { lists }),
  failure: () =>
    createAction(COMMAND_CENTER_DASHBOARD_LOAD_DEPARTMENT.FAITLURE),
}

// *load section
const commandCenterLoadSection = {
  request: (data, loading) =>
    createAction(COMMAND_CENTER_DASHBOARD_LOAD_SECTION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(COMMAND_CENTER_DASHBOARD_LOAD_SECTION.SUCCESS, { lists }),
  failure: () => createAction(COMMAND_CENTER_DASHBOARD_LOAD_SECTION.FAITLURE),
}

// *load plant
const commandCenterLoadPlant = {
  request: (data, loading) =>
    createAction(COMMAND_CENTER_DASHBOARD_LOAD_PLANT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(COMMAND_CENTER_DASHBOARD_LOAD_PLANT.SUCCESS, { lists }),
  failure: () => createAction(COMMAND_CENTER_DASHBOARD_LOAD_PLANT.FAITLURE),
}

export {
  REMOVE_LISTS,
  removeLists,
  LOAD_COMMAND_CENTER_DASHBOARD_STOCK,
  loadCommandCenterDashboardStock,
  COMMAND_CENTER_DASHBOARD_LOAD_DIVISION,
  commandCenterLoadDivision,
  COMMAND_CENTER_DASHBOARD_LOAD_DEPARTMENT,
  commandCenterLoadDepartment,
  COMMAND_CENTER_DASHBOARD_LOAD_SECTION,
  commandCenterLoadSection,
  COMMAND_CENTER_DASHBOARD_LOAD_PLANT,
  commandCenterLoadPlant,
}
